import ScrollObserver from "./ScrollObserver";
import { inview } from "./inview";

export const instaFeed = () => {
  const apiURL = "https://graph.facebook.com/v15.0/";
  const igBusinessId = "17841452587770764";
  const access_token =
    "EAAJqJQMGLWgBAHrKh5S0Ya66SG4ipSUyJTcokMXQa0fFKGvZA8cjyLDkdnD9B2TNUKEZCZBTYrS8QqSK74PaXMO3z7RMymEdQAtg01GVpucwZABoUZCBwuC3B4ZCezSeZAb84WPBBRQwc1GeHyPBKljCsZBbwP2X28imDZAEDUOJZCLFerfUnTKhevjypZCh1o4kceTKzBaLVDVQwZDZD";
  const instaFeedList = document.querySelector(".js-instaFeed");

  document.addEventListener("DOMContentLoaded", () => {
    if (instaFeedList != undefined) {
      getInstagram();
    }
  });

  // Instagramの投稿を取得
  // --------------------------------------
  const getInstagram = (url = "") => {
    const api =
      url ||
      `${apiURL}${igBusinessId}/media?fields=id,like_count,media_type,media_url,thumbnail_url,permalink&access_token=${access_token}`;
    // `${apiURL}${igBusinessId}/media?fields=caption,children,comments_count,id,like_count,media_type,media_url,thumbnail_url,permalink&access_token=${access_token}`;

    fetch(api)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.data !== undefined) {
          createGallery(data.data);

          // scroll
          // ----------------------------
          const fadeAnimation = new ScrollObserver(".js-scroll", inview, {
            once: true,
            rootMargin: "0% 0% 0px",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // Instagramの投稿を表示
  // --------------------------------------
  const createGallery = (media) => {
    let counter = 0;
    media.forEach((item, index) => {
      if (counter >= 6) {
        return true;
      }
      // console.log(item);
      const tile = document.createElement("li");
      tile.innerHTML = `<a href="${item.permalink}" target="_blank" rel="noopenner noreferer"> <img src="${item.media_url}" class="js-scroll" loading="lazy"></a>`;
      instaFeedList.appendChild(tile);
      counter++;
      // console.log(counter);
    });
  };
};
